import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const AlertsSolid = (props: SvgIconT.Props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    paths={[
      'M14 12H6V9c0-1.862 1.277-3.414 3-3.86V5c0-.552.448-1 1-1s1 .448 1 1v.141c1.721.447 3 1.998 3 3.859v3zm-9 1v1h3c0 1.105.895 2 2 2s2-.895 2-2h3v-1H5z',
    ]}
  />
);

export default AlertsSolid;
